<template>
  <v-dialog 
  v-model="dialog" 
  content-class="green-dialog" 
  scrollable 
  persistent 
  transition="c-anim-slide-left-fade"
  :fullscreen="$vuetify.breakpoint.xs" 
  max-width="400px">

    <v-card class="dialog-root-card">
        
      <v-card-title class="dialog-title-bar">
        <v-layout align-center>
          <v-btn
          icon
          class="light-blue--text"
          round @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <span class="title font-weight-medium black--text">
            {{ id ? 'Edit user' : 'New user' }}
          </span>
          <v-spacer></v-spacer>
          <v-btn
          icon
          flat
          class="light-blue--text"
          round @click.native="confirm"
          :loading="loading">
            <v-icon>check</v-icon>
          </v-btn>
        </v-layout>
      </v-card-title>
    
      <v-card-text class="dialog-card-body">

        <div class="c-flex-c1">
        <img style="align-self: center;" src="@/assets/img/illustrations/sugar-and-cinnamon.png" alt="cardboard box" width="80px">

          <v-text-field
          v-model.trim="username" 
          label="Name" 
          required
          :counter="200"
          :error-messages="nameErrors"
          @input="$v.username.$touch()"
          @blur="$v.username.$touch()"></v-text-field>
          <v-text-field 
          v-model="email" 
          label="Email"
          :counter="500"
          :error-messages="emailErrors"></v-text-field>

          <!--
            IF EDIT MODE & USER EXISTS
            -->
          <v-layout
          v-if="id">

            <v-btn
            round
            class="white--text crx-gradient-green font-weight-bold"
            @click="inviteUser(id, email)">Send invite
            </v-btn>

          </v-layout>

        </div>
      </v-card-text>
    </v-card>

  </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  data () {
    return {
      dialog: false,
      id: null,
      username: '',
      email: '',
      error: '',
      loading: false
    }
  },
  computed: {
    nameErrors () {
      const errors = []
      if (!this.$v.username.$dirty) return errors
      !this.$v.username.maxLength && errors.push('Name must be less than 200 characters')
      !this.$v.username.required && errors.push('Name is required.')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.maxLength && errors.push('Email must be less than 500 characters')
      return errors
    }
  },
  validations: {
    username: { required, maxLength: maxLength(200) },
    email: { maxLength: maxLength(500) }
  },
  methods: {
    new () {
      // 5
      this.$v.$reset()
      this.id = null
      this.username = ''
      this.email = ''
      this.dialog = true
    },
    edit (item) {
      // 5
      this.$v.$reset()
      this.id = item.id
      this.username = item.username
      this.email = item.email
      this.dialog = true
    },
    confirm () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('Invalid')
      } else {
        if (this.id !== null) {
          this.updateItem()
        } else {
          this.createItem()
        }
      }
    },
    createItem () {
      this.loading = true
      this.error = ''
      this.$axios.post('users/create',
        {
          username: this.username,
          email: this.email
        },
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            this.dialog = false
            this.$emit('on-refresh')
          })
        .catch(
          (error) => {
            this.error = JSON.stringify(error.response.data.errors)
            this.$root.$errorSnackbar(error)
          })
        .then(() => {
          this.loading = false
        })
        // */
    },
    updateItem () {
      this.loading = true
      this.error = ''
      this.$axios.patch('users',
        {
          id: this.id,
          username: this.username,
          email: this.email
        },
        {headers: {'Content-Type': 'application/json'}})
        .then(
          (response) => {
            this.$emit('on-refresh')
            this.dialog = false
          })
        .catch(
          (error) => {
            this.error = JSON.stringify(error.response.data.errors)
            this.$root.$errorSnackbar(error)
          })
        .then(() => {
          this.loading = false
        })
        // */
    },
    inviteUser (userID, email) {
      var data = {
        id: userID,
        email: email
      }
      this.$axios.post('users/invite-user',
        data,
        {headers: {'Content-Type': 'application/json'}})
        .then(response => {
        })
        .catch(error => {
          this.$root.$errorSnackbar(error)
        })
    }
  }
}
</script>

<style scoped>

</style>
